const FaqsTabs = () => {
  const faqsTabs = [...document.querySelectorAll(".tabs-links__faqs-tabs-item")];
  const faqsBlocks = [...document.querySelectorAll(".tabs-links__faqs-block .accordion__list")];

  const handlers = [];

  const resetTabs = () => {
    faqsTabs.forEach((faqsTab, index) => {
      faqsTab.classList.remove("active");
      const title = faqsTab.querySelector(".item-title");

      if (handlers[index]) {
        title.removeEventListener("click", handlers[index]);
      }
    });
    faqsBlocks.forEach((block) => block.classList.remove("active"));
  };

  const updateTabs = () => {
    const windowWidth = window.innerWidth;

    resetTabs();

    if (faqsTabs.length > 0) {
      if (windowWidth > 767) {
        faqsTabs[0].classList.add("active");
        faqsBlocks[0].classList.add("active");
        
        faqsTabs.forEach((faqsTab, index) => {
          const title = faqsTab.querySelector(".item-title");

          const handler = () => {
            faqsTabs.forEach((tab) => tab.classList.remove("active"));
            faqsBlocks.forEach((block) => block.classList.remove("active"));

            faqsTab.classList.add("active");
            faqsBlocks[index].classList.add("active");
          };

          handlers[index] = handler;

          title.addEventListener("click", handler);
        });
      }

      if (windowWidth <= 767) {
        faqsTabs.forEach((faqsTab, index) => {
          const title = faqsTab.querySelector(".item-title");

          const handler = () => {
            const isActive = faqsTab.classList.contains("active");

            faqsTabs.forEach((tab) => tab.classList.remove("active"));

            if (!isActive) {
              faqsTab.classList.add("active");
            }
          };

          handlers[index] = handler;

          title.addEventListener("click", handler);
        });
      }
    }
  };

  updateTabs();

  window.addEventListener('resize', updateTabs);
};

export default FaqsTabs;

